import { NoImage } from "@assets/constant/index.constant";
import Tooltip from "@ui/external/components/tooltip";
import { ZoomImage } from "@ui/internal/components/formelement";
import { useHandleAction } from "@utils/hook/index.hook";
import { useSelectionStore } from "@utils/states/index.state";

const ColumnList = () => {
  const { clearSelection } = useSelectionStore();
  const { handleAction } = useHandleAction({});
  return [
    {
      name: "ID",

      cell: (row: any) => (
        <span className="font-semibold text-gray-700">{row?.id}</span>
      ),
      sortable: true,
    },
    {
      name: "Image",

      cell: (row: any) => (
        <div className="flex items-center gap-3">
          <ZoomImage>
            <img
              src={row.image || NoImage}
              alt="featured"
              onError={(e: any) => {
                const target = e.target as HTMLImageElement;
                target.onerror = null;
                target.src = NoImage;
              }}
              className="object-cover size-12 border rounded-md "
            />
          </ZoomImage>
        </div>
      ),
      sortable: false,
    },

    {
      name: "Title",

      cell: (row: any) => (
        <Tooltip description={row.name}>
          <div className="text-lg max-w-[200px]  flex flex-wrap max-h-16 justify-start break-all capitalize font-semibold text-gray-800">
            <span className="truncate capitalize">{row.name}</span>
          </div>
        </Tooltip>
      ),
      sortable: true,
    },
    {
      name: "Actions",
      cell: (row: any) => (
        <div className="flex items-center gap-3  cursor-pointer">
          <button
            className="cursor-pointer text-[#1DA077]"
            onClick={() => handleAction({ type: "modal-edit", data: row.id })}
          >
            Edit
          </button>
          <button
            className="cursor-pointer text-[#C33241]"
            onClick={() => {
              clearSelection();
              handleAction({
                type: "confirm",
                data: { type: "delete", id: row.id },
              });
            }}
          >
            Delete
          </button>
        </div>
      ),
      sortable: false,
    },
  ];
};

export { ColumnList };
